import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Container,
  Image,
  Nav,
  Row,
  Form,
  Dropdown,
  Accordion,
} from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import Login from "../../../../../../Components/Login";
import { useHistory } from "react-router-dom";
import { Drawer } from "@mui/material";
import {
  Email_details,
  ImageUrl,
  client_name,
  contact_number,
} from "../../../../../../Helpers/request";
import {
  isDesktop,
  isMobile,
  isMobileOnly,
  isTablet,
} from "react-device-detect";
import { AiOutlineClose } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { BsFillChatFill, BsFillTelephoneFill } from "react-icons/bs";
import { IoMdMail, IoMdContact } from "react-icons/io";
import { img_url } from "../../../../../../Helpers/request";

import HeaderStyle from "../../../../../../Assets/css/megamenu.module.css";

import {
  currencyCode,
  currencyFlag,
  currencyIcon,
  loginDrawer,
} from "../../../../../../Reducer/homeReducer";
import { LazyLoadImage } from "react-lazy-load-image-component";
import LogoImg from "../../../../../../Assets/images/new-logo-black.png";
import { FaPhoneVolume } from "react-icons/fa6";
import { IoTime } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";

const MegaMenu = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [setDesktopSearch, setShowDesktopSearch] = useState(false);
  const [submenu, setSubmenu] = useState([]);
  const [show, setShow] = useState(false);
  const [topHeader, setTopHeader] = useState(true);
  const [left, setLeft] = useState(false);
  const [ringBuiliderClear, setRingBuiliderClear] = useState(false);
  const [hover, setHover] = useState(0);
  const [search_text, setSearch_text] = useState("");
  const menudata = useSelector((state) => state.persistedReducer.home.menu);
  const currencycode = useSelector(
    (state) => state.persistedReducer.home.currencycode,
  );
  const currencyflag = useSelector(
    (state) => state.persistedReducer.home.currencyflag,
  );
  const currencydata = useSelector(
    (state) => state.persistedReducer.home.currency,
  );
  const user = useSelector((state) => state.persistedReducer.home.userData);
  useEffect(() => {
    document.body.className = window.location.pathname;
    return () => {
      document.body.className = "";
    };
  }, [window.location.pathname]);

  const [
    isScrollValueMoreThanHeaderHeight,
    setIsScrollValueMoreThanHeaderHeight,
  ] = useState(false);

  const cartlength = useSelector(
    (state) => state.persistedReducer.cart.cartlength,
  );
  const wishlistlength = useSelector(
    (state) => state.persistedReducer.wish.whishlistlength,
  );
  const toggleDrawer = (open) => {
    setLeft(open);
  };

  useEffect(() => {
    // googleTranslateElementInit()
    const handleScroll = () => {
      setIsScrollValueMoreThanHeaderHeight(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        includedLanguages: "en,es,fr,de,iw,ja,zh-CN,sv,tr,ar,hi",
        gaTrack: true,
      },
      "google_translate_element",
    );
  };
  // const history = useHistory();
  // bw-stud-settingdata
  // useEffect(() => {
  //   if (window.location.pathname === "/complete-diamond-stud" && !JSON.parse(localStorage.getItem("bw-stud-settingdata")) && !JSON.parse(localStorage.getItem("bw-stud-diamonddata"))) {
  //     history.push('/')
  //   }
  // }, [window.location.pathname])

  useEffect(() => {
    if (
      ringBuiliderClear &&
      JSON.parse(localStorage.getItem("bw-settingdata"))
    ) {
      if (window.location.pathname.includes("/gemstones")) {
        localStorage.removeItem("bw-settingdata");
        sessionStorage.setItem("bw-step", JSON.stringify([2, 3]));
        setRingBuiliderClear(false);
      } else if (window.location.pathname.includes("/fancy-color-diamond")) {
        localStorage.removeItem("bw-settingdata");
        sessionStorage.setItem("bw-step", JSON.stringify([0, 3]));
        setRingBuiliderClear(false);
      } else {
        localStorage.removeItem("bw-settingdata");
        sessionStorage.setItem("bw-step", JSON.stringify([1, 3]));
        setRingBuiliderClear(false);
      }
    }
  }, [ringBuiliderClear]);
  useEffect(() => {
    //  if (props.location.pathname !== "/stud-settings") {
    sessionStorage.removeItem("bw_s_filter");
    // }
  }, [window.location.pathname]);

  const currencyHandle = async (code, img, icon) => {
    await dispatch(currencyIcon(icon));
    await dispatch(currencyCode(code));
    await dispatch(currencyFlag(img));
    localStorage.removeItem("bw-fancycolordata");
    localStorage.removeItem("bw-gemstonedata");
    localStorage.removeItem("bw-diamonddata");
    localStorage.removeItem("bw-settingdata");
    sessionStorage.removeItem("bw-listfilter");
    sessionStorage.removeItem("bw_f_filter");
    sessionStorage.removeItem("bw_s_filter");
    sessionStorage.removeItem("bw_d_filter");
    sessionStorage.removeItem("bw_g_filter");
    sessionStorage.removeItem("bw-list-category");
    if (window.location.pathname == "/complete-diamond-ring") {
      history.push("/diamonds");
    } else if (window.location.pathname == "/complete-gemstone-ring") {
      history.push("/gemstones");
    } else if (window.location.pathname == "/complete-fancycolor-ring") {
      history.push("/fancy-color-diamond");
    }
    window.location.reload();
  };
  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const resizeScreen = () => {
    setScreenWidth(window.innerWidth);
  };
  useEffect(() => {
    resizeScreen();
    window.addEventListener("resize", resizeScreen);
    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  });

  const divRef = useRef(null);
  const [divHeight, setDivHeight] = useState(0);

  useEffect(() => {
    if (menudata.length > 0 && divRef.current) {
      setDivHeight(divRef.current.offsetHeight);
    }
  }, [menudata]);

  return (
    <>
      {/* Top Header Section */}
      {topHeader ? (
        isDesktop ? (
          <div className={"rcs_top_header " + HeaderStyle.Showcase_top_header}>
            <Container fluid>
              <div
                className={
                  "rcs_top_head_content  text-center" +
                  HeaderStyle.Showcase_top_head_content
                }
              >
                <p
                  className={
                    HeaderStyle.Showcase_top_head_text +
                    "d-flex align-items-center"
                  }
                >
                  <svg
                    className="mr-2"
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    height="1.4em"
                    width="1.4em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm96 240h-96a16 16 0 01-16-16V128a16 16 0 0132 0v128h80a16 16 0 010 32z"></path>
                  </svg>
                  TUE - SAT 11:00 AM - 06:00 PM | SUN 12:00 PM - 05:00 PM
                </p>
              </div>
            </Container>
          </div>
        ) : (
          ""
        )
      ) : (
        ""
      )}
      <div
        ref={divRef}
        className={`rcs_header_seaction ${
          isScrollValueMoreThanHeaderHeight
            ? "rcs_logo_head rcs_sticky-top sticky-top"
            : "rcs_logo_head"
        }`}
        id="rcs_header_seaction"
      >
        {/* Top Header Section */}

        <div>
          <div>
            {/* Header Section */}
            {isMobile ? (
              <>
                <div
                  className={
                    "rcs_top_header pt-lg-0 pt-2 pb-lg-0 pb-md-2 pb-3 pb-sm-0 pb-xs-0 " +
                    HeaderStyle.Showcase_top_header
                  }
                >
                  <Container
                    className={
                      "rcs_custom_home_container " +
                      HeaderStyle.Showcase_custom_home_container
                    }
                  >
                    <div
                      className={
                        "rcs_top_head_content " +
                        HeaderStyle.Showcase_top_head_content
                      }
                    >
                      <ul className="rcs_top_head_content_list_mobile">
                        <li className="mb-1">
                          <span
                            style={{ verticalAlign: "middle", paddingRight: 5 }}
                          >
                            <IoTime />
                          </span>
                          TUE - SAT 11:00 AM - 06:00 PM | SUN 12:00 PM - 05:00
                          PM
                        </li>
                        <li>
                          <a href={contact_number.link}>
                            <FaPhoneVolume className="mr-2" />
                            {contact_number.text}{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </Container>

                  {/* <div className="showcaseversion">
                    <p className="text">Showcase Version</p>
                    <ul className="versoinlist">
                      <li>
                        <a href="/">Version 1</a>
                      </li>
                      <li>
                        <a href="https://showcase2.demobw.com/">Version 2</a>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </>
            ) : (
              ""
            )}
            <div className="rcs_header">
              <Container fluid>
                {/* Center Header */}
                <div className={HeaderStyle.showcase_center_header}>
                  <Row className="d-flex align-items-center">
                    {isMobile ? (
                      <Col xs={4} md={5} className="align-self-center">
                        <Nav className="m-auto rcs_mobile_header_menu">
                          <span
                            onClick={() => {
                              toggleDrawer(true);
                              dispatch(loginDrawer(false));
                            }}
                            width="30px"
                          >
                            <RxHamburgerMenu color="var(--primary)" />
                          </span>
                        </Nav>
                      </Col>
                    ) : (
                      <Col md={5} className="d-flex align-items-center">
                        <div
                          className={HeaderStyle.showcase_center_header_left}
                        >
                          <ul>
                            {/* <li
                              onClick={(e) => {
                                window.location.href = Email_details.link;
                              }}
                            >
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                stroke-width="0"
                                viewBox="0 0 512 512"
                                height="1.4em"
                                width="1.4em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm96 240h-96a16 16 0 01-16-16V128a16 16 0 0132 0v128h80a16 16 0 010 32z"></path>
                              </svg>
                              TUE - SAT 11:00 AM - 06:00 PM | SUN 12:00 PM -
                              05:00 PM
                            </li> */}
                            <li>
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M9.60946 10.3936C12.9337 13.7169 13.6878 9.87218 15.8044 11.9873C17.8449 14.0272 19.0177 14.4359 16.4324 17.0205C16.1085 17.2808 14.051 20.4118 6.82018 13.183C-0.411557 5.95325 2.71766 3.89362 2.97798 3.56988C5.56956 0.978123 5.97123 2.15774 8.01175 4.19769C10.1283 6.31366 6.28522 7.07026 9.60946 10.3936Z"
                                  fill="currentColor"
                                />
                              </svg>
                              <a href={contact_number.link}>
                                {contact_number.text}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    )}
                    <Col xs={4} md={2}>
                      <div
                        className={
                          "mg_menu_logo_main_div " +
                          HeaderStyle.showcase_center_header_center
                        }
                      >
                        <div className=" rcs_logo_section text-center">
                          {/* <NavLink to="/"> */}
                          <Image
                            width={50}
                            onClick={() => history.push("/")}
                            src={LogoImg}
                            alt={client_name.c_name}
                          ></Image>
                          {/* </NavLink> */}
                        </div>
                      </div>
                    </Col>

                    {isMobile ? (
                      <Col md={5} xs={4} className="align-self-center">
                        <div className="rcs_right_side rcs_right_side_mobile1">
                          <ul>
                            <li>
                              <Login />
                            </li>
                            <li>
                              <div
                                className="showacase_mobile_login  position-relative"
                                onClick={() => toggleDrawer(false)}
                              >
                                <div
                                  className="d-flex justify-content-start align-items-center"
                                  onClick={() =>
                                    user?.isLogin
                                      ? history.push("/account/wishlist")
                                      : history.push("/wishlist")
                                  }
                                >
                                  <svg
                                    className="rcs_cart_mobile_icon1"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M15.8498 2.5007C16.4808 2.5007 17.1108 2.5897 17.7098 2.7907C21.4008 3.9907 22.7308 8.0407 21.6198 11.5807C20.9898 13.3897 19.9598 15.0407 18.6108 16.3897C16.6798 18.2597 14.5608 19.9197 12.2798 21.3497L12.0298 21.5007L11.7698 21.3397C9.48077 19.9197 7.34977 18.2597 5.40077 16.3797C4.06077 15.0307 3.02977 13.3897 2.38977 11.5807C1.25977 8.0407 2.58977 3.9907 6.32077 2.7697C6.61077 2.6697 6.90977 2.5997 7.20977 2.5607H7.32977C7.61077 2.5197 7.88977 2.5007 8.16977 2.5007H8.27977C8.90977 2.5197 9.51977 2.6297 10.1108 2.8307H10.1698C10.2098 2.8497 10.2398 2.8707 10.2598 2.8897C10.4808 2.9607 10.6898 3.0407 10.8898 3.1507L11.2698 3.3207C11.3616 3.36967 11.4647 3.4445 11.5537 3.50917C11.6102 3.55014 11.661 3.58704 11.6998 3.6107C11.7161 3.62033 11.7327 3.63001 11.7494 3.63977C11.8351 3.68982 11.9245 3.74196 11.9998 3.7997C13.1108 2.9507 14.4598 2.4907 15.8498 2.5007ZM18.5098 9.7007C18.9198 9.6897 19.2698 9.3607 19.2998 8.9397V8.8207C19.3298 7.4197 18.4808 6.1507 17.1898 5.6607C16.7798 5.5197 16.3298 5.7407 16.1798 6.1607C16.0398 6.5807 16.2598 7.0407 16.6798 7.1897C17.3208 7.4297 17.7498 8.0607 17.7498 8.7597V8.7907C17.7308 9.0197 17.7998 9.2407 17.9398 9.4107C18.0798 9.5807 18.2898 9.6797 18.5098 9.7007Z"
                                      fill="var(--primary)"
                                    />
                                  </svg>

                                  {wishlistlength && wishlistlength != "0" ? (
                                    <span className="rcs_wish_badge new-mob-wish">
                                      {wishlistlength}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </li>
                            <li
                              onClick={() => {
                                history.push("/cart");
                              }}
                            >
                              <svg
                                className="rcs_cart_mobile_icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.42578 18.9082C8.25512 18.9082 8.93455 19.6018 8.93457 20.459C8.93457 21.306 8.25514 22 7.42578 22C6.58656 21.9999 5.90723 21.3059 5.90723 20.459C5.90725 19.6019 6.58657 18.9083 7.42578 18.9082ZM18.667 18.9082C19.4963 18.9082 20.1758 19.6018 20.1758 20.459C20.1758 21.306 19.4963 22 18.667 22C17.8278 21.9999 17.1484 21.3059 17.1484 20.459C17.1485 19.6019 17.8278 18.9083 18.667 18.9082ZM2.01074 2.64062C2.08068 2.22329 2.47026 1.94664 2.87988 2.00879L5.26367 2.375C5.60318 2.43742 5.85285 2.72251 5.88281 3.06934L6.07227 5.35547C6.10242 5.68267 6.36224 5.9275 6.68164 5.92773H20.1768C20.7862 5.92778 21.1863 6.14194 21.5859 6.61133C21.9854 7.0807 22.0547 7.75412 21.9648 8.36523L21.0156 15.0596C20.8358 16.3463 19.7571 17.2947 18.4883 17.2949H7.58594C6.25726 17.2947 5.15885 16.255 5.04883 14.9082L4.12891 3.7832L2.62012 3.51855C2.22052 3.4471 1.94092 3.04875 2.01074 2.64062ZM14.1211 9.70215C13.7015 9.70226 13.3721 10.0392 13.3721 10.4678C13.3721 10.8861 13.7015 11.2333 14.1211 11.2334H16.8887C17.3083 11.2334 17.6387 10.8862 17.6387 10.4678C17.6387 10.0392 17.3083 9.70215 16.8887 9.70215H14.1211Z"
                                  fill="var(--primary)"
                                />
                              </svg>
                              {cartlength && cartlength != "0" ? (
                                <span className="rcs_cart_badge">
                                  {cartlength}
                                </span>
                              ) : (
                                ""
                              )}
                            </li>
                          </ul>
                        </div>
                      </Col>
                    ) : isTablet ? (
                      <Col>
                        <div className="rcs_right_side rcs_right_side_mobile1">
                          <ul>
                            <li>
                              <Login />
                            </li>
                            <li
                              onClick={() => {
                                history.push("/cart");
                              }}
                            >
                              <svg
                                className="rcs_cart_mobile_icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.42578 18.9082C8.25512 18.9082 8.93455 19.6018 8.93457 20.459C8.93457 21.306 8.25514 22 7.42578 22C6.58656 21.9999 5.90723 21.3059 5.90723 20.459C5.90725 19.6019 6.58657 18.9083 7.42578 18.9082ZM18.667 18.9082C19.4963 18.9082 20.1758 19.6018 20.1758 20.459C20.1758 21.306 19.4963 22 18.667 22C17.8278 21.9999 17.1484 21.3059 17.1484 20.459C17.1485 19.6019 17.8278 18.9083 18.667 18.9082ZM2.01074 2.64062C2.08068 2.22329 2.47026 1.94664 2.87988 2.00879L5.26367 2.375C5.60318 2.43742 5.85285 2.72251 5.88281 3.06934L6.07227 5.35547C6.10242 5.68267 6.36224 5.9275 6.68164 5.92773H20.1768C20.7862 5.92778 21.1863 6.14194 21.5859 6.61133C21.9854 7.0807 22.0547 7.75412 21.9648 8.36523L21.0156 15.0596C20.8358 16.3463 19.7571 17.2947 18.4883 17.2949H7.58594C6.25726 17.2947 5.15885 16.255 5.04883 14.9082L4.12891 3.7832L2.62012 3.51855C2.22052 3.4471 1.94092 3.04875 2.01074 2.64062ZM14.1211 9.70215C13.7015 9.70226 13.3721 10.0392 13.3721 10.4678C13.3721 10.8861 13.7015 11.2333 14.1211 11.2334H16.8887C17.3083 11.2334 17.6387 10.8862 17.6387 10.4678C17.6387 10.0392 17.3083 9.70215 16.8887 9.70215H14.1211Z"
                                  fill="var(--primary)"
                                />
                              </svg>
                              {cartlength && cartlength != "0" ? (
                                <span className="rcs_cart_badge">
                                  {cartlength}
                                </span>
                              ) : (
                                ""
                              )}
                            </li>
                          </ul>
                        </div>
                      </Col>
                    ) : (
                      <Col
                        md={5}
                        className="d-flex align-items-center justify-content-end"
                      >
                        <div
                          className={
                            "mg_menu_right_side_area " +
                            HeaderStyle.showcase_center_header_right
                          }
                        >
                          <div className="rcs_right_side rcs_right_side_mobile d-none d-md-block d-lg-block">
                            <ul>
                              <li className="d-none d-md-block d-lg-block">
                                <div
                                  className={
                                    setDesktopSearch == true
                                      ? "show " +
                                        " rcs_search_bar " +
                                        HeaderStyle.DesktopSearch
                                      : "close " +
                                        " rcs_search_bar " +
                                        HeaderStyle.DesktopSearch
                                  }
                                >
                                  {setDesktopSearch == true && (
                                    <Form
                                      onSubmit={(e) => {
                                        e.preventDefault();
                                        history.push("/search/" + search_text);
                                        window.scrollTo(0, 0);
                                        setSearch_text("");
                                        setShowDesktopSearch(false);
                                      }}
                                    >
                                      <Form.Control
                                        type="text"
                                        placeholder="Search for.."
                                        value={search_text}
                                        onChange={(e) =>
                                          setSearch_text(e.target.value)
                                        }
                                      />
                                      <AiOutlineClose
                                        className={
                                          HeaderStyle.DesktopSearchClose
                                        }
                                        onClick={() =>
                                          setShowDesktopSearch(false)
                                        }
                                      />
                                    </Form>
                                  )}
                                </div>

                                <svg
                                  onClick={() =>
                                    setShowDesktopSearch(!setDesktopSearch)
                                  }
                                  width="18"
                                  height="18"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M19.7112 18.3373L15.2347 13.8554C16.3899 12.3855 17.0878 10.5542 17.0878 8.55422C17.0878 3.83133 13.2611 0 8.54392 0C3.82671 0 0 3.83133 0 8.55422C0 13.2771 3.82671 17.1084 8.54392 17.1084C10.5656 17.1084 12.4188 16.4096 13.8628 15.2289L18.3393 19.7108C18.5319 19.9036 18.7726 20 19.0132 20C19.2539 20 19.4946 19.9036 19.7112 19.7108C20.0963 19.3253 20.0963 18.7229 19.7112 18.3373ZM1.92539 8.55422C1.92539 4.89157 4.88568 1.92771 8.54392 1.92771C12.2022 1.92771 15.1625 4.89157 15.1625 8.55422C15.1625 12.2169 12.2022 15.1807 8.54392 15.1807C4.88568 15.1807 1.92539 12.2169 1.92539 8.55422Z"
                                    fill="var(--primary)"
                                  />
                                </svg>
                              </li>

                              <li
                                className="d-none d-md-block d-lg-block"
                                onClick={() =>
                                  user?.isLogin
                                    ? history.push("/account/wishlist")
                                    : history.push("/wishlist")
                                }
                              >
                                <svg
                                  className="rcs_cart_mobile_icon1"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M15.8498 2.5007C16.4808 2.5007 17.1108 2.5897 17.7098 2.7907C21.4008 3.9907 22.7308 8.0407 21.6198 11.5807C20.9898 13.3897 19.9598 15.0407 18.6108 16.3897C16.6798 18.2597 14.5608 19.9197 12.2798 21.3497L12.0298 21.5007L11.7698 21.3397C9.48077 19.9197 7.34977 18.2597 5.40077 16.3797C4.06077 15.0307 3.02977 13.3897 2.38977 11.5807C1.25977 8.0407 2.58977 3.9907 6.32077 2.7697C6.61077 2.6697 6.90977 2.5997 7.20977 2.5607H7.32977C7.61077 2.5197 7.88977 2.5007 8.16977 2.5007H8.27977C8.90977 2.5197 9.51977 2.6297 10.1108 2.8307H10.1698C10.2098 2.8497 10.2398 2.8707 10.2598 2.8897C10.4808 2.9607 10.6898 3.0407 10.8898 3.1507L11.2698 3.3207C11.3616 3.36967 11.4647 3.4445 11.5537 3.50917C11.6102 3.55014 11.661 3.58704 11.6998 3.6107C11.7161 3.62033 11.7327 3.63001 11.7494 3.63977C11.8351 3.68982 11.9245 3.74196 11.9998 3.7997C13.1108 2.9507 14.4598 2.4907 15.8498 2.5007ZM18.5098 9.7007C18.9198 9.6897 19.2698 9.3607 19.2998 8.9397V8.8207C19.3298 7.4197 18.4808 6.1507 17.1898 5.6607C16.7798 5.5197 16.3298 5.7407 16.1798 6.1607C16.0398 6.5807 16.2598 7.0407 16.6798 7.1897C17.3208 7.4297 17.7498 8.0607 17.7498 8.7597V8.7907C17.7308 9.0197 17.7998 9.2407 17.9398 9.4107C18.0798 9.5807 18.2898 9.6797 18.5098 9.7007Z"
                                    fill="var(--primary)"
                                  />
                                </svg>

                                {wishlistlength && wishlistlength !== "0" ? (
                                  <span className="rcs_wish_badge">
                                    {wishlistlength}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </li>
                              <li
                                className="d-none d-lg-block"
                                onClick={() => {
                                  history.push("/cart");
                                }}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.42578 18.9082C8.25512 18.9082 8.93455 19.6018 8.93457 20.459C8.93457 21.306 8.25514 22 7.42578 22C6.58656 21.9999 5.90723 21.3059 5.90723 20.459C5.90725 19.6019 6.58657 18.9083 7.42578 18.9082ZM18.667 18.9082C19.4963 18.9082 20.1758 19.6018 20.1758 20.459C20.1758 21.306 19.4963 22 18.667 22C17.8278 21.9999 17.1484 21.3059 17.1484 20.459C17.1485 19.6019 17.8278 18.9083 18.667 18.9082ZM2.01074 2.64062C2.08068 2.22329 2.47026 1.94664 2.87988 2.00879L5.26367 2.375C5.60318 2.43742 5.85285 2.72251 5.88281 3.06934L6.07227 5.35547C6.10242 5.68267 6.36224 5.9275 6.68164 5.92773H20.1768C20.7862 5.92778 21.1863 6.14194 21.5859 6.61133C21.9854 7.0807 22.0547 7.75412 21.9648 8.36523L21.0156 15.0596C20.8358 16.3463 19.7571 17.2947 18.4883 17.2949H7.58594C6.25726 17.2947 5.15885 16.255 5.04883 14.9082L4.12891 3.7832L2.62012 3.51855C2.22052 3.4471 1.94092 3.04875 2.01074 2.64062ZM14.1211 9.70215C13.7015 9.70226 13.3721 10.0392 13.3721 10.4678C13.3721 10.8861 13.7015 11.2333 14.1211 11.2334H16.8887C17.3083 11.2334 17.6387 10.8862 17.6387 10.4678C17.6387 10.0392 17.3083 9.70215 16.8887 9.70215H14.1211Z"
                                    fill="var(--primary)"
                                  />
                                </svg>

                                {cartlength && cartlength != "0" ? (
                                  <span className="rcs_cart_badge">
                                    {cartlength}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </li>
                              <li className="d-none d-md-block d-lg-block">
                                <Login />
                              </li>
                              {/* <li>
                                <Dropdown
                                  className={
                                    "d-inline rcs_dropdown_lang " +
                                    HeaderStyle.showcase_new_lang
                                  }
                                >
                                  <Dropdown.Toggle id="dropdown-autoclose-true">
                                    <Image
                                      src={currencyflag}
                                      alt={currencycode}
                                    ></Image>
                                    <span>{currencycode}</span>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    {currencydata?.map((val) => (
                                      <Dropdown.Item
                                        onClick={() => {
                                          currencyHandle(
                                            val.currency_code,
                                            val.country_flag,
                                            val.currency_icon
                                          );
                                        }}
                                        href="#"
                                      >
                                        <Image
                                          src={val.country_flag}
                                          alt={val.currency_code}
                                        ></Image>
                                        <span> {val.currency_code}</span>
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </li> */}
                            </ul>
                          </div>
                        </div>
                      </Col>
                    )}

                    {isMobile ? (
                      <Col xs={12} className="d-none">
                        <div className="rcs_search_bar mobileSearchBox">
                          <Form
                            onSubmit={(e) => {
                              e.preventDefault();
                              history.push("/search/" + search_text);
                              window.scrollTo(0, 0);
                              setSearch_text("");
                              setShowDesktopSearch(false);
                            }}
                          >
                            {/* <SearchIcon
                          onClick={(e) => {
                            history.push("/search/" + search_text);
                            setSearch_text("");
                            
                          }}
                        /> */}
                            <svg
                              onClick={(e) => {
                                history.push("/search/" + search_text);
                                setSearch_text("");
                              }}
                              width="16"
                              height="16"
                              style={{ opacity: "0.3" }}
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19.7112 18.3373L15.2347 13.8554C16.3899 12.3855 17.0878 10.5542 17.0878 8.55422C17.0878 3.83133 13.2611 0 8.54392 0C3.82671 0 0 3.83133 0 8.55422C0 13.2771 3.82671 17.1084 8.54392 17.1084C10.5656 17.1084 12.4188 16.4096 13.8628 15.2289L18.3393 19.7108C18.5319 19.9036 18.7726 20 19.0132 20C19.2539 20 19.4946 19.9036 19.7112 19.7108C20.0963 19.3253 20.0963 18.7229 19.7112 18.3373ZM1.92539 8.55422C1.92539 4.89157 4.88568 1.92771 8.54392 1.92771C12.2022 1.92771 15.1625 4.89157 15.1625 8.55422C15.1625 12.2169 12.2022 15.1807 8.54392 15.1807C4.88568 15.1807 1.92539 12.2169 1.92539 8.55422Z"
                                fill="currentColor"
                              ></path>
                            </svg>
                            <Form.Control
                              type="text"
                              placeholder="Search for.."
                              value={search_text}
                              onChange={(e) => setSearch_text(e.target.value)}
                            />
                            {/* <AiOutlineClose
                          onClick={() => setSearch_show(!search_show)}
                        /> */}
                          </Form>
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                </div>

                <>
                  <div className={HeaderStyle.showcase_bottom_header}>
                    {/* Menu Section */}
                    <div className="rcs_menu menu_list_main">
                      <Container fluid className="rcs_custome_container1">
                        <Row>
                          <nav id="rcs_menu_header_top">
                            <ul className="rcs_header_menu">
                              {menudata?.map((value, index) => (
                                <li
                                  className={
                                    "rcs_top_header_menu " +
                                    HeaderStyle.showcase_top_header_menu
                                  }
                                  onMouseEnter={() => {
                                    setHover(1);
                                    setSubmenu(value);
                                  }}
                                  onMouseLeave={() => setHover(0)}
                                >
                                  <h6 className="1st">
                                    <NavLink
                                      to={value?.slug}
                                      onClick={() => setHover(0)}
                                    >
                                      {value?.name}
                                    </NavLink>
                                  </h6>
                                  {/* {(value?.design == 5) ? (
                                    <ul
                                      className="rcs_top_header_menu_dropdown singleColumn"
                                      onMouseEnter={() => setHover(1)}
                                      onMouseLeave={() => setHover(0)}
                                    >
                                      {submenu?.submenu?.map((val) => (
                                        <li className="dir rcs_top_header_menu1">
                                          <span>
                                            <NavLink to={val?.slug}>
                                              {val.name.charAt(0).toUpperCase() + val.name.slice(1).toLowerCase()}
                                            </NavLink>
                                          </span>
                                        </li>
                                      ))}
                                    </ul>
                                  ) : (
                                    ""
                                  )} */}
                                  {value?.design == 5 &&
                                  (value?.menu_id == 350 ||
                                    value?.menu_id == 360) ? (
                                    <ul
                                      className="rcs_top_header_menu_dropdown singleColumn"
                                      onMouseEnter={() => setHover(1)}
                                      onMouseLeave={() => setHover(0)}
                                    >
                                      {submenu?.menu_id == 360
                                        ? submenu?.submenu?.length > 0 &&
                                          submenu?.submenu?.map(
                                            (item3, index) => {
                                              const lastIndex =
                                                index ===
                                                submenu?.submenu?.length - 1;
                                              return (
                                                <li
                                                  className={`flyMenu ${!lastIndex ? "mb-3" : ""} ${index === 0 ? "mt-1" : ""}`}
                                                >
                                                  <NavLink
                                                    to={item3?.slug}
                                                    style={{
                                                      fontWeight: "normal",
                                                    }}
                                                  >
                                                    {item3?.name
                                                      ?.charAt(0)
                                                      .toUpperCase() +
                                                      item3?.name
                                                        ?.slice(1)
                                                        .toLowerCase()}
                                                  </NavLink>
                                                </li>
                                              );
                                            },
                                          )
                                        : submenu?.submenu?.map((section) => (
                                            <React.Fragment
                                              key={section.menu_id}
                                            >
                                              {section?.submenu?.length > 0 &&
                                                section?.submenu?.map(
                                                  (item) => (
                                                    <li
                                                      className="dir rcs_top_header_menu1"
                                                      key={item.menu_id}
                                                    >
                                                      <span>
                                                        {/* <NavLink to={item?.slug}>
                {item?.name}
              </NavLink> */}
                                                        {item?.submenu?.length >
                                                          0 &&
                                                          item?.submenu?.map(
                                                            (item2) => (
                                                              <div>
                                                                <NavLink
                                                                  to={
                                                                    item2?.slug
                                                                  }
                                                                  style={{
                                                                    fontWeight: 700,
                                                                    color:
                                                                      "black !important",
                                                                  }}
                                                                >
                                                                  {item2?.name
                                                                    ?.charAt(0)
                                                                    .toUpperCase() +
                                                                    item2?.name
                                                                      ?.slice(1)
                                                                      .toLowerCase()}
                                                                </NavLink>
                                                                <div className="pl-0">
                                                                  {item2.submenu.map(
                                                                    (item3) => (
                                                                      <li
                                                                        style={{
                                                                          marginTop:
                                                                            "0 !important",
                                                                        }}
                                                                      >
                                                                        <NavLink
                                                                          to={
                                                                            item3?.slug
                                                                          }
                                                                          style={{
                                                                            fontWeight:
                                                                              "normal",
                                                                          }}
                                                                        >
                                                                          {item3?.name
                                                                            ?.charAt(
                                                                              0,
                                                                            )
                                                                            .toUpperCase() +
                                                                            item3?.name
                                                                              ?.slice(
                                                                                1,
                                                                              )
                                                                              .toLowerCase()}
                                                                        </NavLink>
                                                                      </li>
                                                                    ),
                                                                  )}
                                                                </div>
                                                              </div>
                                                            ),
                                                          )}
                                                      </span>
                                                    </li>
                                                  ),
                                                )}
                                            </React.Fragment>
                                          ))}
                                    </ul>
                                  ) : (
                                    ""
                                  )}
                                </li>
                              ))}
                            </ul>
                          </nav>
                        </Row>
                      </Container>
                    </div>
                  </div>
                  {/*mega menu */}
                  <div className="menu_item_main">
                    {submenu?.design != 5 ? (
                      <div
                        onMouseEnter={() => setHover(1)}
                        onMouseLeave={() => setHover(0)}
                        className={
                          hover == "1" && submenu?.submenu?.length
                            ? "rcs_top_header_menu_dropdown mega_menu_content_main visible bw-" +
                              submenu?.name?.replaceAll(" ", "-")
                            : "rcs_top_header_menu_dropdown mega_menu_content_main invisible"
                        }
                      >
                        <div className="rcs_megaMenu d-block">
                          <div className="rcs_megaMenu_inner_top">
                            <div className="rcs_megaMenu_inner">
                              <Container fluid className="p-0">
                                <Row className="w-100 m-auto  justify-content-center">
                                  {submenu?.submenu?.map((val, index) => (
                                    <>
                                      {submenu?.menu_id == "322" ? (
                                        <>
                                          <Col
                                            lg={val?.col}
                                            xl={val?.col}
                                            className="pl-0 mt-4"
                                          >
                                            {val?.submenu?.map((val11) =>
                                              val11?.menu_id == "348" ? (
                                                <LazyLoadImage
                                                  src={val11?.img_url}
                                                  className="img-fluid"
                                                  onClick={() => {
                                                    setHover(0);
                                                    history.push(val11.slug);
                                                  }}
                                                  style={{ cursor: "pointer" }}
                                                  alt={val11?.alt_tag}
                                                />
                                              ) : (
                                                <>
                                                  <div className="text-center watch_image_text_outer">
                                                    <div className="watch_image_text_outer_img_box">
                                                      <LazyLoadImage
                                                        src={val11?.img_url}
                                                        className="watch_imagess"
                                                        onClick={() => {
                                                          setHover(0);
                                                          history.push(
                                                            val11.slug,
                                                          );
                                                        }}
                                                        alt={val11?.alt_tag}
                                                      />
                                                    </div>

                                                    <h2 className=" font-bold text-uppercase mtb watch_image_text">
                                                      {val11?.name}
                                                    </h2>
                                                  </div>
                                                </>
                                              ),
                                            )}
                                          </Col>
                                        </>
                                      ) : (
                                        <Col
                                          lg={val?.col}
                                          xl={val?.col}
                                          className="pl-0"
                                        >
                                          {val?.submenu?.map((val1) =>
                                            val1?.design == "1" ? (
                                              <div
                                                className={
                                                  "rcs_diamonds_content mj_daimond_d_font bw-" +
                                                  val1?.name?.replaceAll(
                                                    " ",
                                                    "-",
                                                  )
                                                }
                                              >
                                                <div
                                                  className={
                                                    "mega-list-cat " +
                                                    HeaderStyle.megaListCat
                                                  }
                                                >
                                                  <h2 className="title14 font-bold text-uppercase mtb">
                                                    {val1?.name}
                                                  </h2>
                                                  <ul>
                                                    {val1?.submenu?.map(
                                                      (val2) => (
                                                        <li>
                                                          {val2?.design == 4 ? (
                                                            <Link
                                                              to="#"
                                                              onClick={() => {
                                                                window.open(
                                                                  img_url +
                                                                    val2?.slug,
                                                                  "_target",
                                                                );
                                                                setHover(0);
                                                              }}
                                                            >
                                                              {val2?.img_url
                                                                ?.length ? (
                                                                <LazyLoadImage
                                                                  src={
                                                                    val2?.img_url
                                                                  }
                                                                  className="img-size"
                                                                  alt={
                                                                    val2?.alt_tag
                                                                  }
                                                                />
                                                              ) : (
                                                                ""
                                                              )}
                                                              {val2?.name}
                                                            </Link>
                                                          ) : (
                                                            <Link
                                                              to={val2?.slug}
                                                              onClick={() =>
                                                                setHover(0)
                                                              }
                                                            >
                                                              {val2?.img_url
                                                                ?.length ? (
                                                                <LazyLoadImage
                                                                  src={
                                                                    val2?.img_url
                                                                  }
                                                                  className="img-size"
                                                                  alt={
                                                                    val2?.alt_tag
                                                                  }
                                                                />
                                                              ) : (
                                                                ""
                                                              )}
                                                              {val2?.name}
                                                            </Link>
                                                          )}
                                                        </li>
                                                      ),
                                                    )}
                                                  </ul>
                                                </div>
                                              </div>
                                            ) : val1?.design == "2" ? (
                                              <div
                                                className={
                                                  "rcs_diamonds_content dfL-border_rel bw-" +
                                                  val1?.name?.replaceAll(
                                                    " ",
                                                    "-",
                                                  )
                                                }
                                              >
                                                <h2> {val1?.name} </h2>
                                                <div className="m-auto w-100 row">
                                                  {val1?.submenu?.map(
                                                    (val2) => (
                                                      <div className="cust_padd_diamonds_shape col-lg-6">
                                                        <div className="rcs_diamonds_content_inner">
                                                          <Link
                                                            to={val2?.slug}
                                                            onClick={() => {
                                                              setHover(0);
                                                              if (
                                                                val2?.slug.includes(
                                                                  "shape",
                                                                )
                                                              ) {
                                                                setRingBuiliderClear(
                                                                  true,
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            {val2?.img_url
                                                              ?.length ? (
                                                              <LazyLoadImage
                                                                src={
                                                                  val2?.img_url
                                                                }
                                                                alt={
                                                                  val2?.alt_tag
                                                                }
                                                              />
                                                            ) : (
                                                              ""
                                                            )}
                                                            <p>{val2?.name}</p>
                                                          </Link>
                                                        </div>
                                                      </div>
                                                    ),
                                                  )}
                                                </div>
                                              </div>
                                            ) : val1?.design == "3" ? (
                                              <div className="rcs_diamonds_content">
                                                <Link
                                                  to={val1?.slug}
                                                  onClick={() => setHover(0)}
                                                >
                                                  {val1?.img_url?.length ? (
                                                    <LazyLoadImage
                                                      src={val1?.img_url}
                                                      alt={
                                                        val1?.alt_tag
                                                          ? val1?.alt_tag
                                                          : val1?.name
                                                      }
                                                      className="img-fluid dfl_ddiamond_img"
                                                      style={{
                                                        height: "100%",
                                                        objectFit: "cover",
                                                      }}
                                                    />
                                                  ) : (
                                                    ""
                                                  )}
                                                </Link>
                                              </div>
                                            ) : (
                                              ""
                                            ),
                                          )}
                                          {index < 2 ? (
                                            <div className="dfl_menu_border"></div>
                                          ) : (
                                            ""
                                          )}
                                        </Col>
                                      )}
                                    </>
                                  ))}
                                </Row>
                              </Container>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </>
                {isMobileOnly && (
                  <Row>
                    <Col sm={12} md={12} className="px-1">
                      <div className="rcs_search_bar mobileSearchBox front_mobile_search px-2 mt-2">
                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            history.push("/search/" + search_text);
                            window.scrollTo(0, 0);
                            setSearch_text("");

                            toggleDrawer(false);
                          }}
                        >
                          {/* <SearchIcon
                          onClick={(e) => {
                            history.push("/search/" + search_text);
                            setSearch_text("");
                            
                          }}
                        /> */}

                          <Form.Control
                            type="text"
                            placeholder="Search for.."
                            value={search_text}
                            onChange={(e) => setSearch_text(e.target.value)}
                          />
                          {/* <AiOutlineClose
                          onClick={() => setSearch_show(!search_show)}
                        /> */}
                        </Form>
                        <svg
                          onClick={(e) => {
                            history.push("/search/" + search_text);
                            setSearch_text("");
                          }}
                          width="16"
                          height="16"
                          style={{ opacity: "0.3" }}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.7112 18.3373L15.2347 13.8554C16.3899 12.3855 17.0878 10.5542 17.0878 8.55422C17.0878 3.83133 13.2611 0 8.54392 0C3.82671 0 0 3.83133 0 8.55422C0 13.2771 3.82671 17.1084 8.54392 17.1084C10.5656 17.1084 12.4188 16.4096 13.8628 15.2289L18.3393 19.7108C18.5319 19.9036 18.7726 20 19.0132 20C19.2539 20 19.4946 19.9036 19.7112 19.7108C20.0963 19.3253 20.0963 18.7229 19.7112 18.3373ZM1.92539 8.55422C1.92539 4.89157 4.88568 1.92771 8.54392 1.92771C12.2022 1.92771 15.1625 4.89157 15.1625 8.55422C15.1625 12.2169 12.2022 15.1807 8.54392 15.1807C4.88568 15.1807 1.92539 12.2169 1.92539 8.55422Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </div>
                    </Col>
                  </Row>
                )}
              </Container>
            </div>

            {/* Header Section */}

            {hover == "1" && submenu?.submenu?.length ? (
              <div className="hover_overlayer"></div>
            ) : (
              ""
            )}
          </div>
        </div>
        {/* Mobile Menu Section */}
        <div className="rcs_menu_mobile d-none">
          <Drawer anchor="left" open={left} onClose={() => toggleDrawer(false)}>
            <div
              role="presentation"
              // onKeyDown={() => toggleDrawer(false)}
            >
              <div
                className={
                  show === true ? "mobile-menu" : "mobile-menu nav-open"
                }
              >
                {/* <div className="mobile-auth-with-currency d-flex align-items-center justify-content-between p-2">

                  <div className="">
                    <Dropdown
                      className={
                        "d-inline rcs_dropdown_lang " +
                        HeaderStyle.showcase_new_lang
                      }
                    >
                      <Dropdown.Toggle id="dropdown-autoclose-true">
                        <Image
                          src={currencyflag}
                          alt={currencycode}
                        ></Image>
                        <span>{currencycode}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {currencydata?.map((val) => (
                          <Dropdown.Item
                            onClick={() => {
                              currencyHandle(
                                val.currency_code,
                                val.country_flag,
                                val.currency_icon
                              );
                            }}
                            href="#"
                          >
                            <Image
                              src={val.country_flag}
                              alt={val.currency_code}
                            ></Image>
                            <span> {val.currency_code}</span>
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div> */}
                <div className="inner-mobile-menu">
                  {isMobileOnly ? (
                    " "
                  ) : (
                    <div className="rcs_search_bar mobileSearchBox px-2 mt-2">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          history.push("/search/" + search_text);
                          window.scrollTo(0, 0);
                          setSearch_text("");

                          toggleDrawer(false);
                        }}
                        className="position-relative"
                      >
                        {/* <SearchIcon
                          onClick={(e) => {
                            history.push("/search/" + search_text);
                            setSearch_text("");
                            
                          }}
                        /> */}
                        <svg
                          onClick={(e) => {
                            history.push("/search/" + search_text);
                            setSearch_text("");
                          }}
                          width="16"
                          height="16"
                          style={{ opacity: "0.3" }}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.7112 18.3373L15.2347 13.8554C16.3899 12.3855 17.0878 10.5542 17.0878 8.55422C17.0878 3.83133 13.2611 0 8.54392 0C3.82671 0 0 3.83133 0 8.55422C0 13.2771 3.82671 17.1084 8.54392 17.1084C10.5656 17.1084 12.4188 16.4096 13.8628 15.2289L18.3393 19.7108C18.5319 19.9036 18.7726 20 19.0132 20C19.2539 20 19.4946 19.9036 19.7112 19.7108C20.0963 19.3253 20.0963 18.7229 19.7112 18.3373ZM1.92539 8.55422C1.92539 4.89157 4.88568 1.92771 8.54392 1.92771C12.2022 1.92771 15.1625 4.89157 15.1625 8.55422C15.1625 12.2169 12.2022 15.1807 8.54392 15.1807C4.88568 15.1807 1.92539 12.2169 1.92539 8.55422Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <Form.Control
                          type="text"
                          placeholder="Search for.."
                          value={search_text}
                          onChange={(e) => setSearch_text(e.target.value)}
                        />
                        {/* <AiOutlineClose
                          onClick={() => setSearch_show(!search_show)}
                        /> */}
                      </Form>
                    </div>
                  )}

                  <Accordion defaultActiveKey="0">
                    {/* <Accordion.Item eventKey="0">
                                <Accordion.Header><Link to="#"><span className='auth'><LazyLoadImage src={User} alt="" /></span> LOGIN/SIGNUP</Link></Accordion.Header>
                            </Accordion.Item> */}
                    {menudata?.map((val, index) => (
                      <Accordion.Item eventKey={index}>
                        <Accordion.Header
                          className={`${
                            val.name === "Custom Design" ? "no_button" : ""
                          }`}
                        >
                          <Link
                            to={val.slug}
                            onClick={() => toggleDrawer(false)}
                          >
                            {val.name}
                          </Link>
                        </Accordion.Header>
                        <Accordion.Body>

                          {val?.menu_id == "360" &&
                            val?.design == "5" &&
                            val?.submenu?.length && (
                              <ul className="my-3">
                                {val?.submenu?.map((elm, ind) => (
                                  <li onClick={()=>toggleDrawer(false)} key={ind} className={`${ind===val?.submenu?.length - 1 ? "" : "mb-2"}`}>
                                    <NavLink
                                      to={elm?.slug}
                                      style={{ fontWeight: "normal" }}
                                    >
                                      {elm?.name?.charAt(0).toUpperCase() +
                                        elm?.name?.slice(1).toLowerCase()}
                                    </NavLink>
                                  </li>
                                ))}
                              </ul>
                            )}

                          {val?.submenu?.map((val1) =>
                            val1?.submenu?.map((val2) =>
                              val2?.design == 3 ? (
                                <LazyLoadImage
                                  className="w-100 mt-2"
                                  onClick={() => history.push(val2?.slug)}
                                  src={val2?.img_url}
                                  alt={val2?.alt_tag}
                                />
                              ) : (
                                <>
                                  {val2?.img_url ? (
                                    <div className="d-flex align-items-center watch_img_text_box_mobile ">
                                      <LazyLoadImage
                                        src={val2?.img_url}
                                        alt={val2?.alt_tag}
                                        className="watch_img_mobile"
                                        onClick={() => {
                                          history.push(val2?.slug);
                                          toggleDrawer(false);
                                        }}
                                      />
                                      <h2
                                        className="title"
                                        onClick={() => {
                                          history.push(val2?.slug);
                                          toggleDrawer(false);
                                        }}
                                      >
                                        {val2?.name}
                                      </h2>
                                    </div>
                                  ) : (
                                    <>
                                      <h2 className="title">
                                        {val2?.name !== "Brands"
                                          ? val2?.name
                                          : ""}
                                      </h2>
                                      <ul
                                        className={
                                          val2?.design == 2
                                            ? "two-col-list"
                                            : "single-col-list"
                                        }
                                      >
                                        {val2?.submenu?.map((val3) => (
                                          <li>
                                            <Link
                                              onClick={() => {
                                                toggleDrawer(false);
                                                setRingBuiliderClear(true);
                                              }}
                                              to={val3.slug}
                                            >
                                              {val3?.img_url ? (
                                                <LazyLoadImage
                                                  src={val3?.img_url}
                                                  alt={val3?.alt_tag}
                                                />
                                              ) : (
                                                ""
                                              )}
                                              {val?.menu_id == 350 ||
                                              val?.menu_id == 360 ? (
                                                <h6>{val3?.name}</h6>
                                              ) : (
                                                <span>{val3?.name}</span>
                                              )}
                                            </Link>
                                            {val?.design == "5" &&
                                            (val?.menu_id == "350" ||
                                              val?.menu_id == "360") ? (
                                              <>
                                                <li className="dir rcs_top_header_menu1">
                                                  <span>
                                                    <div className="pb-2">
                                                      {val3.submenu.map(
                                                        (item3) => (
                                                          <li
                                                            style={{
                                                              marginTop:
                                                                "0 !important",
                                                            }}
                                                          >
                                                            <NavLink
                                                              to={item3?.slug}
                                                              style={{
                                                                fontWeight:
                                                                  "normal",
                                                              }}
                                                            >
                                                              {item3?.name
                                                                ?.charAt(0)
                                                                .toUpperCase() +
                                                                item3?.name
                                                                  ?.slice(1)
                                                                  .toLowerCase()}
                                                            </NavLink>
                                                          </li>
                                                        ),
                                                      )}
                                                    </div>
                                                  </span>
                                                </li>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </li>
                                        ))}
                                      </ul>
                                    </>
                                  )}
                                </>
                              ),
                            ),
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}

                    <Accordion.Item eventKey="7" className="contactDetail">
                      <Accordion.Header>Contact us</Accordion.Header>
                      <div className="contact_detail">
                        <ul>
                          {/* <li>
                                <a
                                  onClick={() => setShow(false)}
                                  target="_blank"
                                href="https://api.whatsapp.com/send?phone=+6469929024 &amp;text=Hi Arman Jwelers ! I have a few queries. Could you please help me out?"

                                href={"https://api.whatsapp.com/send?phone=" + contact_number.chat +  " &amp;text=Hi " + client_name.c_name + "! I have a few queries. Could you please help me out?"}
                                >
                                  <span>
                                    <BsFillChatFill />
                                  </span>
                                  Chat
                                </a>
                              </li> */}
                          <li>
                            <a
                              onClick={() => {
                                setShow(false);
                                window.location.href = contact_number.link;
                              }}
                              href="#"
                            >
                              <span>
                                <BsFillTelephoneFill />
                              </span>
                              Call
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={(e) => {
                                setShow(false);
                                window.location.href = Email_details.link;
                              }}
                            >
                              <span>
                                <IoMdMail />
                              </span>
                              Email
                            </a>
                          </li>
                          <li onClick={() => toggleDrawer(false)}>
                            <Link onClick={() => setShow(false)} to="/contact">
                              <span>
                                <IoMdContact />
                              </span>
                              Contact
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          </Drawer>
        </div>
        {/* Mobile Menu Section */}
      </div>
    </>
  );
};
export default MegaMenu;
